import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  options: {
    customProperties: true,
  },
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: '#5AA680',
        accent: '#E7B137',
        secondary: '#B2B2B2',
        success: '#5AA680',
        info: '#2196F3',
        warning: '#FB8C00',
        error: '#FF5252',
        blueGrey: '#2e3e48'
      },
      light: {
        primary: '#5AA680',
        accent: '#E7B137',
        secondary: '#455C6C',
        success: '#5AA680',
        info: '#42A5F5',
        warning: '#FFA726',
        error: '#EF5350',
        blueGrey: '#2e3e48'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
});
